<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocheading">Contents</h1>
<h2 class="L1"><a href="#/xhtml/05_Introduction"><span class="bold">Introduction</span></a></h2>
<h2 class="L1"><a href="#/xhtml/06_Chapter_001"><span class="bold">Assault Gun Units of the Heer</span></a></h2>
<h2 class="L1"><span href="#/xhtml/07_Chapter_002" title="Link target outside of Sample"><span class="bold">Camouflage &amp; Markings</span></span></h2>
<h2 class="L1"><span href="#/xhtml/08_Chapter_003" title="Link target outside of Sample"><span class="bold">Model Showcase</span></span></h2>
<h2 class="L1"><span href="#/xhtml/09_Chapter_004" title="Link target outside of Sample"><span class="bold">Modelling Products</span></span></h2>
<h2 class="L1"><span href="#/xhtml/10_Chapter_005" title="Link target outside of Sample"><span class="bold">Assault Gun Units of the Waffen-SS</span></span></h2>
<h2 class="L1"><span href="#/xhtml/11_Chapter_006" title="Link target outside of Sample"><span class="bold">Assault Gun Units of the Luftwaffe</span></span></h2>
<h2 class="L1"><span href="#/xhtml/12_Chapter_007" title="Link target outside of Sample"><span class="bold">Technical Details and Modifications</span></span></h2>
<h2 class="L1"><span href="#/xhtml/13_Chapter_008" title="Link target outside of Sample"><span class="bold">Product Contact Details</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?18e5f9fe